import {
    ActionTypes
} from "../type";

export const getLabDeptlist = (id) => async (dispatch) => {
    try {
        dispatch({
            type: ActionTypes.SET_LAB_DEPT_ID,
            payload: id
        })
    } catch (err) {
        throw (err)
    }
}